export default __webpack_public_path__ + "static/media/studentCSV.a8816a81.csv";